export const profilePath = 'profile';
export const ordersPath = 'orders';
export const checkoutPath = 'checkout';
export const orderCompletePath = 'order-complete';
export const cartPath = 'cart';
export const authPath = 'auth'
export const confirmPath = 'confirm'
